import { Link } from 'react-router-dom'
import Card from '@/components/common/Card'
import Badge from '@/components/common/Badge'
import Button from '@/components/common/Button'

function TierStatus({ team }) {
  const isFree = team.season_tier === 'free'
  const dispatchesRemaining = isFree ? Math.max(0, 2 - team.dispatches_sent_this_month) : null
  const seasonEndDate = team.season_end ? new Date(team.season_end).toLocaleDateString() : null

  return (
    <Card>
      <div className="mb-4">
        <div className="flex items-center gap-2 mb-2">
          <h3 className="font-heading text-lg font-bold">
            Current Plan
          </h3>
          <Badge variant={isFree ? 'gray' : 'green'}>
            {isFree ? 'Free' : 'Pro'}
          </Badge>
        </div>
      </div>

      <div className="space-y-4">
        {/* Dispatch Status */}
        <div>
          <div className="text-sm text-brand-slate mb-1">
            Dispatches this month
          </div>
          <div className="text-2xl font-bold text-brand-charcoal tabular-nums">
            {isFree ? (
              <span>
                {dispatchesRemaining} <span className="text-base font-normal text-brand-slate">of 2 left</span>
              </span>
            ) : (
              <span className="text-brand-green">Unlimited</span>
            )}
          </div>
        </div>

        {/* Season End (for paid) */}
        {!isFree && seasonEndDate && (
          <div>
            <div className="text-sm text-brand-slate mb-1">
              Season ends
            </div>
            <div className="text-lg font-medium text-brand-charcoal">
              {seasonEndDate}
            </div>
          </div>
        )}

        {/* Features */}
        <div className="pt-4 border-t border-border">
          <div className="text-sm text-brand-slate mb-2">
            {isFree ? 'Free Tier includes:' : 'Pro includes:'}
          </div>
          <ul className="space-y-2 text-sm">
            {isFree ? (
              <>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>2 dispatches/month</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Up to 25 parent emails</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Basic wiki (add only)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>3 scrimmage postings</span>
                </li>
              </>
            ) : (
              <>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Unlimited dispatches</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Unlimited parent emails</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Full wiki, roster & tasks</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>Calendar auto-sync</span>
                </li>
                <li className="flex items-start">
                  <span className="text-brand-green mr-2">✓</span>
                  <span>File uploads (5GB)</span>
                </li>
              </>
            )}
          </ul>
        </div>

        {/* Upgrade CTA */}
        {isFree && (
          <div className="pt-4">
            <Link to="/pricing">
              <Button variant="primary" className="w-full">
                Upgrade to Pro - $49/season
              </Button>
            </Link>
          </div>
        )}
      </div>
    </Card>
  )
}

export default TierStatus


